module.exports = __webpack_public_path__ + "static/media/logo.9489d9b1.svg";